import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {NavigationPoint} from './navigation-point';

@Injectable({
  providedIn: 'root'
})
export class NavStatusService {
  private activeNavPoint$: Subject<NavigationPoint> = new Subject();
  private iframeIntegrated$: Subject<boolean> = new Subject();

  constructor() { }
  setActiveNavPoint(activeNavPoint: NavigationPoint) {
    this.activeNavPoint$.next(activeNavPoint);
  }
  getActiveNavPoint(): Observable<NavigationPoint> {
    return this.activeNavPoint$.asObservable();
  }
  getIframeIntegrated(): Observable<boolean> {
    return this.iframeIntegrated$.asObservable()
  }
  setIframeIntegrated(to: boolean) {
    this.iframeIntegrated$.next(to);
  }
}
